import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import TooltipExample from "../../components/ui/tooltip";
import PageMeta from "../../components/common/PageMeta";

export default function Tooltips() {
  return (
    <div>
      <PageMeta
        title="React.js Tooltips Tabs | TailAdmin - React.js Admin Dashboard Template"
        description="This is React.js Tabs  page for TailAdmin - React.js Tailwind CSS Admin Dashboard Template"
      />
      <PageBreadcrumb pageTitle="Tooltips" />
      <TooltipExample />
    </div>
  );
}
